export default __webpack_public_path__ + "static/media/18.66d307b2.jpg";